import { render, staticRenderFns } from "./loading-spinner-v2.vue?vue&type=template&id=0a2dd5c3&"
import script from "./loading-spinner-v2.vue?vue&type=script&lang=ts&"
export * from "./loading-spinner-v2.vue?vue&type=script&lang=ts&"
import style0 from "./loading-spinner-v2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports